import styled from "styled-components";

export const Breadcrumb = styled.nav`
  width: 100%;
  margin: 0;

  /* Match the horizontal padding used by your page containers/sections
     so this aligns with the content below it instead of sitting flush
     against the browser edge. Adjust to your actual container gutter
     (e.g. swap for your Container component's padding token). */
  padding: 16px clamp(20px, 5vw, 96px);

  /* Overlay on top of the hero/section behind it instead of being a
     separate solid-colour strip — no background here on purpose. */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  background: transparent;

  display: flex;
  align-items: center;

  font-size: 15px;
  line-height: 1;

  box-sizing: border-box;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const BreadcrumbLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 7px;

  color: #7f7a72;
  text-decoration: none;

  font-size: 15px;
  font-weight: 400;
  line-height: 1;

  transition: color 0.2s ease;

  &:hover {
    color: #315f4b;
  }

  &:focus-visible {
    outline: 2px solid #315f4b;
    outline-offset: 3px;
    border-radius: 3px;
  }

  svg {
    width: 15px;
    height: 15px;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    font-size: 14px;

    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

export const BreadcrumbSep = styled.span`
  display: inline-flex;
  align-items: center;

  margin: 0 8px;

  color: #aaa49c;

  font-size: 16px;
  font-weight: 400;
  line-height: 1;

  user-select: none;
`;

export const BreadcrumbCurrent = styled.span`
  display: inline-flex;
  align-items: center;

  color: #171717;

  font-size: 15px;
  font-weight: 700;
  line-height: 1;

  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 14px;

    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;